module.exports = __webpack_public_path__ + "static/media/Session-Open.e73201b6.svg";